import script from "./Patch24LicenseEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./Patch24LicenseEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__